<p-chip label="label" [removable]="isRemovable"></p-chip>
